import dynamic from 'next/dynamic';

export const AddFavoriteModal = dynamic(() => import('./AddFavoriteModal'));
export type { AddFavoriteModalProps } from './AddFavoriteModal';
export const AnnouncementDetailModal = dynamic(() => import('./AnnouncementDetailModal'));
export type { AnnouncementDetailModalProps } from './AnnouncementDetailModal';
export type {
  AnnouncementContentItem,
  AnnouncementListEntry,
} from './AnnouncementDetailModal/types';

export {
  createAnnouncementBadgeColorMap,
  DEFAULT_ANNOUNCEMENT_BADGE_COLOR,
} from './AnnouncementDetailModal/utils';
export const ErrorModal = dynamic(() => import('./ErrorModal'));
export const UpdateConsoleVersionModal = dynamic(() => import('./UpdateConsoleVersionModal'));
